export async function getHashRH(Id_Empleado) {
  // Obtén el día del mes actual
  const day = new Date().getDate().toString();

  // Concatena las partes necesarias para el hash
  const input = day + "tQatKLFu1Zkleg5fpMEQ2uhRo" + "-" + Id_Empleado;

  // Convierte la cadena a un array de bytes usando TextEncoder
  const encoder = new TextEncoder();
  const inputBytes = encoder.encode(input);

  // Usa la API Web Crypto para generar el hash SHA-1
  const hashBuffer = await crypto.subtle.digest("SHA-1", inputBytes);

  // Convierte el buffer a una cadena en formato hexadecimal
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  // Recorta la cadena resultante para obtener solo los primeros 32 caracteres y retorna en minúsculas
  return hashHex.substring(0, 32).toLowerCase();
}
